import { HttpClient, HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ExportDownloadResponse } from '@api-response-types/export-download.response';
import { ExportForecastOptions } from '@api-types/types/export-forecast-options.interface';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ExportHttpClient {
  private readonly baseUrl = environment.api.url;
  private readonly http = inject(HttpClient);

  public getDownloadData(exportId: string) {
    return this.http.get<ExportDownloadResponse>(
      `${this.baseUrl}/export/download/${exportId}`,
    );
  }

  public generateExport(resultSetId: string, options: ExportForecastOptions) {
    return this.http.post<HttpStatusCode.Created>(
      `${this.baseUrl}/export/${resultSetId}/generate-export`,
      options,
    );
  }
}
